import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Form, Input, Radio } from "antd";
import { ESupportTicketQuestionType } from "@devowl-wp/api-real-commerce";
import { SupportFormNestedFieldsContainer } from "./nestedFieldsContainer.js";
import { __, _i } from "../../utils/i18n.js";
const SupportFormErrorLocationAndBrowserField = (param)=>{
    let { wpInMaintenanceMode } = param;
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, curValues)=>prevValues.questionType !== curValues.questionType,
        children: (param)=>{
            let { getFieldValue } = param;
            return !!getFieldValue("questionType") && getFieldValue("questionType") === ESupportTicketQuestionType.ProblemWithProduct && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Form.Item, {
                        name: "errorLocation",
                        required: true,
                        label: __("Where does the error occur? (URL)"),
                        ...wpInMaintenanceMode ? {
                            hasFeedback: true,
                            validateStatus: "error",
                            help: wpInMaintenanceMode
                        } : {},
                        rules: [
                            {
                                required: true,
                                message: __("Please insert your error location!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Input, {
                            placeholder: "https://example.com/blog"
                        })
                    }),
                    wpInMaintenanceMode && /*#__PURE__*/ _jsx(Form.Item, {
                        name: "disableMaintenanceModeCheck",
                        valuePropName: "checked",
                        label: __("Confirm error location"),
                        rules: [
                            {
                                type: "boolean",
                                required: true,
                                transform: (value)=>value || undefined,
                                message: __("Please confirm that you have entered the correct error location!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsx(Checkbox, {
                            children: _i(__("My website is {{u}}not{{/u}} in maintenance mode and is publicly accessible."), {
                                u: /*#__PURE__*/ _jsx("u", {})
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        label: __("Does the problem appear in multiple browsers (e.g. Google Chrome and Mozilla Firefox)?"),
                        required: true,
                        name: "existsErrorInMultipleBrowsers",
                        rules: [
                            {
                                required: true,
                                message: __("Please choose one option!")
                            }
                        ],
                        children: /*#__PURE__*/ _jsxs(Radio.Group, {
                            children: [
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: true,
                                    children: __("Yes")
                                }),
                                /*#__PURE__*/ _jsx(Radio.Button, {
                                    value: false,
                                    children: __("No")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Form.Item, {
                        noStyle: true,
                        shouldUpdate: (prevValues, curValues)=>prevValues.existsErrorInMultipleBrowsers !== curValues.existsErrorInMultipleBrowsers,
                        children: (param)=>{
                            let { getFieldValue } = param;
                            return getFieldValue("existsErrorInMultipleBrowsers") === false && /*#__PURE__*/ _jsx(SupportFormNestedFieldsContainer, {
                                children: /*#__PURE__*/ _jsx(Form.Item, {
                                    name: "browserToReproduceError",
                                    required: true,
                                    label: __("In which browser (with version number and your operating system) does the error appear?"),
                                    rules: [
                                        {
                                            required: true,
                                            message: __("Please insert a browser name!")
                                        }
                                    ],
                                    children: /*#__PURE__*/ _jsx(Input, {})
                                })
                            });
                        }
                    })
                ]
            });
        }
    });
};
export { SupportFormErrorLocationAndBrowserField };
